import { render } from "./PosterTable.vue?vue&type=template&id=70142862&scoped=true"
import script from "./PosterTable.vue?vue&type=script&lang=js"
export * from "./PosterTable.vue?vue&type=script&lang=js"

import "./PosterTable.vue?vue&type=style&index=0&id=70142862&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70142862"]])

export default __exports__